import React from 'react';
import { Box } from '@mui/material';
import { ServiceProviderOpticDropdown } from '../citizen/serviceprovider/components/service-provider-optic-dropdown';
import { useServiceProviderUnits } from './hooks/use-service-provider-units';

export function ServiceProviderOpticUserScopedContainer() {
  const { units, currentUnit, setCurrentUnit } = useServiceProviderUnits();

  if (!units || units.length === 0) {
    return null;
  }

  return (
    <Box sx={{ ml: 1 }}>
      <ServiceProviderOpticDropdown
        units={units}
        selectedUnitId={currentUnit?.id}
        onSelectUnit={setCurrentUnit}
        selectedUnitAbbreviation={currentUnit?.abbreviation}
      />
    </Box>
  );
}
